<template>

  <div id="user-information-form" class="edit-form">

    <div class="row">

      <div class="materialized col-xs-12 col-sm-6">

        <div class="form-group materialized">

          <input id="firstName"
                 type="text"
                 class="form-control"
                 placeholder="First Name"
                 name="firstName"
                 v-model="userInformation.firstName"
                 v-bind:firstName="userInformation.firstName"
                 :data-vv-scope="validationScope"
                 disabled>

          <label for="firstName">First Name</label>

          <span v-show="errors.has(validationScope + '.firstName')" class="help form-errors">

            {{ errors.first(validationScope + '.firstName') }}

          </span>

        </div>

      </div>

      <div class="materialized col-xs-12 col-sm-6">
        <div class="form-group materialized">
          <input type="text" class="form-control" placeholder="Last Name"
                 id="lastName"
                 name="lastName"
                 v-model="userInformation.lastName"
                 v-bind:lastName="userInformation.lastName"
                 :data-vv-scope="validationScope"
                 disabled>
          <label for="lastName">Last Name</label>
          <span v-show="errors.has(validationScope + '.lastName')" class="help form-errors">
            {{ errors.first(validationScope + '.lastName') }}
          </span>
        </div>
      </div>

    </div>

    <div class="row">

      <div class="materialized col-xs-12 col-sm-6">
        <div class="form-group materialized">
          <input type="text" class="form-control" placeholder="Address 1"
                 id="address-street"
                 name="address-street"
                 v-model="userInformation.address.street"
                 v-bind:address="userInformation.address.street"
                 v-on:input="event => SetAddressInput('street', event.target.value)"
                 :data-vv-scope="validationScope"
                 v-validate="'required'"
                 >
          <label for="address-street">Address 1</label>
          <span v-show="errors.has(validationScope + '.address-street')" class="help form-errors">
            {{ errors.first(validationScope + '.address-street') }}
          </span>
        </div>
      </div>

      <div class="materialized col-xs-12 col-sm-6">
        <div class="form-group materialized">
          <input type="text" class="form-control" placeholder="Address 2"
                 id="address-street2"
                 name="address-street2"
                 v-model="userInformation.address.street2"
                 v-bind:address="userInformation.address.street2"
                 v-on:input="event => SetAddressInput('street2', event.target.value)"
                 :data-vv-scope="validationScope">
          <label for="address-street2">Address 2</label>
          <span v-show="errors.has(validationScope + '.address-street2')" class="help form-errors">
            {{ errors.first(validationScope + '.address-street2') }}
          </span>
        </div>
      </div>

    </div>

    <div class="row">

      <div class="materialized col-xs-12 col-sm-6">
        <div class="form-group materialized">
          <input type="text" class="form-control" placeholder="City"
                 id="address-city"
                 name="address-city"
                 v-model="userInformation.address.city"
                 v-bind:city="userInformation.address.city"
                 v-on:input="event => SetAddressInput('city', event.target.value)"
                 :data-vv-scope="validationScope"
                 v-validate="'required'">
          <label for="address-city">City</label>
          <span v-show="errors.has(validationScope + '.address-city')" class="help form-errors">
            {{ errors.first(validationScope + '.address-city') }}
          </span>
        </div>
      </div>

      <div class="materialized col-xs-6 col-sm-3">
        <div class="form-group materialized">
          <el-select id="address-state"
                     v-model="userInformation.address.state"
                     v-validate="'required'"
                     name="address-state"
                     :data-vv-scope="validationScope"
                     v-on:input="event => SetAddressInput('state', event)"
                     placeholder="Select">

            <el-option popper-class="select-top"
                       v-for="state in states"
                       :key="state"
                       :label="state"
                       :value="state">

            </el-option>
          </el-select>
          <label for="address-state">State</label>
          <span v-show="errors.has(validationScope + '.address-state')"
                class="help form-errors">{{ errors.first(validationScope + '.address-state') }}</span>

        </div>

      </div>

      <div class="materialized col-xs-6 col-sm-3">
        <div class="form-group materialized">
          <input type="text" class="form-control" placeholder="Zip Code"
                 id="address-zip"
                 name="address-zip"
                 v-model="userInformation.address.zipCode"
                 v-bind:zipcode="userInformation.address.zipCode"
                 v-on:input="event => SetZipcodeInput(event.target.value)"
                 :data-vv-scope="validationScope"
                 maxlength="5"
                 v-validate="'required|numeric|digits:5'">
          <label for="address-zip">Zip Code</label>
          <span v-show="errors.has(validationScope + '.address-zip')" class="help form-errors">
            {{ errors.first(validationScope + '.address-zip') }}
          </span>
        </div>
      </div>

    </div>

    <div class="row">

      <div class="materialized col-xs-12 col-sm-6">
        <div class="form-group materialized">
          <the-mask data-vv-name="phone"
                    class="form-control"
                    id="phone"
                    mask="(###) ###-####"
                    v-model="userInformation.phone"
                    v-validate="'required|min:10'"
                    v-bind:phone="userInformation.phone"
                    v-on:input="event => SetUserInfoInput('phone', event)"
                    :data-vv-scope="validationScope"
                    placeholder="Phone">
          </the-mask>
          <label for="phone">Phone</label>
          <span v-show="errors.has(validationScope + '.phone')" class="help form-errors">
            {{ errors.first(validationScope + '.phone') }}
          </span>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
  import { STATE_LIST } from 'my-account-common'

  export default {
    name: 'user-information-form',
    inject: ['$validator'],
    props: {
      validationScope: {
        type: String,
        default: 'userInformation'
      },
      userInformation: {
        type: Object,
        required: true,
        default: function () {
          return {
            firstName: '',
            lastName: '',
            phone: '',
            address: {
              city: '',
              state: '',
              street: '',
              street2: '',
              zipCode: ''
            }
          }
        }
      }
    },
    data () {
      return {
        states: STATE_LIST
      }
    },
    methods: {
      SetAddressInput (field, value) {
        this.userInformation.address[field] = value
        this.$emit('input', this.userInformation)
      },
      SetUserInfoInput (field, value) {
        this.userInformation[field] = value
        this.$emit('input', this.userInformation)
      },
      SetZipcodeInput (value) {
        this.userInformation.address.zipCode = value.replace(/\D/g, '')
        this.$emit('input', this.userInformation)
      }
    }
  }
</script>

<style lang="scss">
  @import '~my-account-common-css/stylesheets/materialized.scss';
  @import '~bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss';
  @import '~my-account-common-css/stylesheets/container.scss';
  @import '~element-ui/lib/theme-default/index.css';

  .edit-form {

    margin-bottom: 20px;

  }

</style>



// WEBPACK FOOTER //
// src/components/UserInformationForm.vue